import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';
import {build_query as  build_query_deal} from '../Orders/_store'

interface CatalogState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    last_deal: any;
    last_deals: any[];
}

const state: CatalogState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    last_deal: {},
    last_deals: [],
};

export const ITEMS_LIST = 'GET_CATALOG_LIST';
export const LAST_DEAL = 'GET_LAST_DEAL';
export const ALL_DELIVERY_POINTS = 'ALL_DELIVERY_POINTS';

const COLUMNS: any = {
    id: 'products.id',
    product_name: 'products.name',
    name: 'products.name',
    code: 'products.code',
    teaser: 'products.teaser',
    promo_name: 'products.promo_name',
    attachments: 'products.attachments',
    archived_at: 'products.archived_at',
    created_at: 'products.created_at',
    updated_at: 'products.updated_at',
    containers: 'grouped_product_containers.containers'
};

export function build_query(query: any, client_id: any, all: boolean = false) {
    const filter: any[] = [];
    const container_filter: any[] = [];
    if (query.name) {
        filter.push({ "$ilike": ["products.name", {"$": `%${query.name}%`}] })
    }
    return {
        "columns": COLUMNS,
        from: 's:products',
        from_as: 'products',
        joins: [
          {
            join: {
              columns: {
                product_id: 'product_containers.product_id',
                containers: {
                    $array_agg: {
                      $obj: {
                        id: 'product_containers.id',
                        name: 'product_containers.name',
                        container_name: 'product_containers.name',
                        container_price: 'client_product_containers.container_price',
                        container_weight: 'product_containers.weight',
                        archived_at: 'product_containers.archived_at',
                        created_at: 'product_containers.created_at',
                        updated_at: 'product_containers.updated_at',
                        price_per_kg: 'product_containers.price_per_kg',
                        ...(
                            query.costPriceDate ?
                            {
                                month: 'prime_costs.month',
                                cost: 'prime_costs.cost',
                                cost_id: 'prime_costs.id',
                            } : {}
                        )
                      }
                    }
                  },
              },
              from: 's:product_containers',
              from_as: 'product_containers',
              ...(
                query.costPriceDate ?
                {
                    joins: [
                        {
                            join: 's:prime_costs',
                            type: 'left',
                            as:   'prime_costs',
                            on: {
                                $and: [
                                    { $eq: ['prime_costs.product_container_id', 'product_containers.id'] },
                                    { $eq: ['prime_costs.month', { $: moment(query.costPriceDate).format('YYYY-MM-DD') } ] }
                                ]
                            }
                        },
                    ],
                } : {}
              ),
              joins: [
                {
                  join: 's:client_product_containers',
                  as: 'client_product_containers',
                  on: {
                    $and: [
                      {$eq: ['client_product_containers.product_container_id', 'product_containers.id']},
                      {$eq: ['client_product_containers.client_id', {$: client_id}]},
                      (all ? {$eq: ["client_product_containers.is_recomended", {$: false}]} : {$eq: ["client_product_containers.is_recomended", {$: true}]}),
                      {
                        $or: [
                          {$not: ['client_product_containers.hidden']},
                          {$lt: ['client_product_containers.hidden_date', {$: moment().utc().local().format('YYYY-MM-DD')}]}
                        ]
                      }
                    ].filter((item: any) => {return item})
                  }
                },
                {
                  join: 's:products',
                  type: 'left',
                  as: 'products',
                  on: {
                    $eq: ['products.id', 'product_containers.product_id']
                  }
                },
              ],
              groups: [
                'product_containers.product_id'
              ],
              where: {
                $and: [
                    {$eq: ['product_containers.is_substandard', {$: false}]},
                    { $null: [ 'products.archived_at' ] },
                    { $null: [ 'product_containers.archived_at' ] },
                    { $or: [
                        { $eq: ['client_product_containers.hidden', {$: false}]},
                        { $null: [ 'client_product_containers.hidden_date' ] },
                    ]}
                ]
              }
            },
            // type: 'left',
            as: 'grouped_product_containers',
            on: { $eq: ['grouped_product_containers.product_id', 'products.id']},
					}
        ],
        ...({page: parseInt(query.page) || 1}),
        ...({
            order: [
                query.sortDirection == 'desc' ? { $desc: [COLUMNS[query.sortField || 'name' ]] } : { $asc: [COLUMNS[query.sortField || 'name']] }
            ]
        }),
        ...(
            filter.length > 1 ?
            {
                "where": {
                    "$and": filter
                }
            } : {
                "where": filter[0]
            }
        )

    }
}


export const actions: ActionTree<CatalogState, RootState> = {
    loadData({ commit, rootState, getters, dispatch }, query) {
        const vm = (this as any)._vm;
        // @ts-ignore
        const client_id = rootState.ubic.actor.document.client_id

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(ITEMS_LIST)
                    .raw('documents.list')
                    .action(build_query(query, client_id)),
                vm.$q(ALL_DELIVERY_POINTS)
                    .select('documents.list')
                    .fileds({
                        id: 'delivery_points.id'
                    })
                    .from('delivery_points')
                    .innerJoin('view_client_parents', (_: any) => {
                      return _.eq('view_client_parents.client_id', `delivery_points.client_id`);
                    })
                    .innerJoin('clients', (_: any) => {
                      return _.eq('clients.parent_id', `view_client_parents.id`);
                    })
                    .where((_: any) => {
                        return _.and([
                            _.or([
                                _.eq(`clients.id`, _.const(client_id)), 
                                _.eq(`clients.parent_id`, _.const(client_id)), 
                            ]),
                            _.null([`delivery_points.archived_at`])
                        ]);
                    })
                    // .action(build_query_deal({last: true}, client_id, 1))
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());

                vm.$db(result.getOperation(ALL_DELIVERY_POINTS).getContent().documents.map((item: any, idx: number) => {
                    return vm.$q(LAST_DEAL + '-' + idx)
                            .raw('documents.list')
                            .action(build_query_deal({delivery_only: true, last: true, delivery_point_id: item.id}, client_id, 1))
                })).then((result: ServerResult) => {
                    commit('SET_LAST_DEAL', result.getContent().map((item: any) => {
                        return item.documents.length ? item.documents[0] : null
                    }).filter((item: any) => {
                        console.log(item)
                        return item != null
                    }));
                    commit('LOADED_SUCCESS');
                    resolve(null);
                })

            }));
        })
    },

    requestSample({state, commit, rootState}, container) {
        const vm = (this as any)._vm;
        const client_id = (rootState as any).ubic.actor.document.client_id

        console.log(container);

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q('GET_CLIENT')
                .raw('documents.get')
                .action({
                    id: client_id
                }),
            ]).then(((result: ServerResult) => {
                const client = result.getOperation('GET_CLIENT').getContent().document;
                vm.$db([
                    vm.$q('CREATE_DEAL')
                        .create('s:deals', {
                            status_id: 'd:statuses:13',
                            name: client.name,
                            client_id: client.id,
                            client_type_id: client.type_id,
                            payment_type_id: client.payment_type_id,
                            type_id: 'd:deals_types:1',
                            source: 'lk',
                        })
                ]).then(((result: ServerResult) => {
                    const deal = result.getOperation('CREATE_DEAL').getContent().document;
                    vm.$db([
                        vm.$q('CREATE_DEAL_ITEMS')
                            .update(deal.id, {})
                            .createManyRelation('deal_product_containers', 'deal_id', (createRelated: any) => {
                                return [createRelated({
                                    product_container_id: container.id,
                                    container_quantity: 1,
                                    container_price: container.container_price,
                                    container_weight: container.container_weight,
                                    is_sample: true
                                })];
                            })
                    ]).then(((result: ServerResult) => {
                        commit('LOADED_SUCCESS');
                        resolve(null);
                    }))
                }))
            }));
        })
    },
};

export const mutations: MutationTree<CatalogState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_LAST_DEAL(state, data) {
        // state.last_deal = data.documents[0];
        state.last_deals = data;
    },
    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_catalog';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
